import { Expose, plainToClass, Transform, Type } from 'class-transformer';

import { StudentPackage } from '../../interface';
import { BaseStudent } from './base-student-model';
import { Model } from './model';

export class StudentsPerformanceReport extends Model {
  @Expose() id: string;
  @Expose()
  @Transform(({ obj }) => plainToClass(BaseStudent, obj, { strategy: 'excludeAll' }))
  @Type(() => BaseStudent)
  student: BaseStudent;

  @Expose() favoriteTeachersCount: number;
  @Expose() highestPaidAmount: number;
  @Expose() numOfPurchases: number;
  @Expose() plusThirtySecondsCallsCount: number;
  @Expose() reservedSlotsCount: number;
  @Expose() reservedTeachersCount: number;
  @Expose() assignmentValue: number;
  @Expose() activePercentagePerSelectedPeriodOnly: number;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  lastConnectionDate: Date;
  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : null))
  lastPurchaseDate: Date;
  @Expose() studentPackagesGrouped: StudentPackage;
  @Expose() subscribeToTeachersCount: number;
  @Expose() totalCompletedCallsCount: number;
  @Expose() totalConsumedMinutes: number;
  @Expose() totalExpiredAvailableMinutes: number;
  @Expose() totalFiledCallsCount: number;
  @Expose() totalMissedCallsCount: number;
  @Expose() totalNotExpiredAvailableMinutes: number;
  @Expose() totalPackageMinutes: number;
  @Expose() studentStatus: string;
  @Expose() remainingMinutesAfterSession: string;
  @Expose() purchasingPerConsultantCount: string;
  @Expose() userId: string;
}
